// generated from 829 samples

import { z } from "zod";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const inAppPurchaseFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("in_app_purchase_filter"),
  comparison_key: z.enum([
    "3", // 531 (64.05%)
    "5", // 157 (18.94%)
    "1", // 141 (17.01%)
  ]),
  display_name: z.string(),
  // undefined: 177 (21.35%), defined 652 (78.65%)
  // integer: 637 (97.70%)
  // avg: 1173.49, min: -300, max: 500000
  raw_value: z.number().optional(),
  // integer: 813 (98.07%)
  // avg: 296909.58, min: -300, max: 245345656
  value: z.number(),
  varies_by_app_group: z.literal(false),
});
